import { useQuery } from '@tanstack/react-query';
import { getNutritionByPeriod } from '../../../api/nutrition-service';

const useGetNutritionByPeriod = (dateStart, dateEnd) => {
    const { data, isLoading, isError, error } = useQuery({
        queryKey: ['nutrition', 'period', dateStart, dateEnd],
        queryFn: () => getNutritionByPeriod(dateStart, dateEnd),
        enabled: !!dateStart && !!dateEnd,
        staleTime: 1000 * 60 * 5,
        keepPreviousData: true,
        refetchOnWindowFocus: false
    });

    return { data, isLoading, isError, error };
};

export default useGetNutritionByPeriod;
